import { getCookie, getLocale } from '@pb/utils'

export const getReactLocale = (): string => {
  // Locales with non-market matching URLS
  const exemptionLocales = ['en_eur', 'en_asia1', 'zh_asia1', 'en_asia3', 'zh_asia3', 'en_asia5']
  // These URLS have a cookie to see which market they are on (not for all markets)
  const localeFromCookie = getCookie('HMCORP_locale') as string
  const currentLocale = getLocale('lowerCase')
  return !exemptionLocales.includes(currentLocale) ? getLocale('mixed') : localeFromCookie
}
